import { Component, OnInit, ViewChild, } from "@angular/core";
import { VernostServiceService } from "../../../../services/vernost-service.service";
import { MatInput } from "@angular/material";
import { DatePipe } from "@angular/common";
import { Router } from "@angular/router";
import { saveAs } from "file-saver";
import { CommonService } from "../../../../services/common.service";

@Component({
  selector: 'app-fcr',
  templateUrl: './fcr.component.html',
  providers: [DatePipe]
})
export class FcrComponent implements OnInit {
  @ViewChild("input", { read: MatInput }) input: MatInput;
  @ViewChild("input2", { read: MatInput }) input2: MatInput;
  @ViewChild("input3", { read: MatInput }) input3: MatInput;
  @ViewChild("input4", { read: MatInput }) input4: MatInput;

  screentitle: string = "FC Report";
  headerDivName: string = "errMsgDiv";
  Errmessage: string = "";
  search_details;
  final;
  IsEmptyVal: boolean = false;
  disablebtn = true;
  isJpNumber: boolean = false;
  IsErr: boolean = false;
  isPnr: boolean = false;
  isOrd: boolean = false;
  isEMT: boolean = false;
  isFname: boolean = false;
  isLname: boolean = false;
  journeydate: boolean = false;
  showsingle1: boolean = true;
  showMultiple1: boolean = true;
  downd: boolean = true;
  bookingdate: boolean = false;
  tomorrow1;
  // mydate = new Date();
  myDate: any = new Date();
  newDate: any = new Date();
  noresult: any = "";
  loader: boolean = false;
  searchlist: boolean = true;
  cancelbtn;
  search_result_list: any = [];
  order_Id_list: any = [];
  search_detail_list: any = [];
  p: number = 1;
  totalItems: number = 1;
  uid;

  constructor(private datePipe: DatePipe,
    private router: Router,
    private vernostService: VernostServiceService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.cancelbtn = true;
    this.search_details = {
      jp_number: "",
      order_id: "",
      first_name: "",
      last_name: "",
      airlinepnr: "",
      status: "E",
      isMailSent: "",
      tripdate_from: "",
      tripdate_to: "",
      bookingdate_from: "",
      bookingdate_to: "",
      Ticket_No: "",
      emt: "",
      supplier_id: ""
    };
    this.uid = localStorage.getItem("uid");
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
  }

  ngAfterContentInit() {
    this.search_details.bookingdate_to = new Date();
    this.search_details.bookingdate_from = new Date();
    this.final = this.search_details.bookingdate_to.setDate(
      this.search_details.bookingdate_to.getDate()
    );
    this.final = new Date(this.final);
    this.IsEmptyVal = true;
    // this.searchData();
  }

  keypresshandler(event) {
    var charCode = event.keyCode;
    //Non-numeric character range
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  }

  isEmpty() {
    if (
      this.search_details.jp_number == "" &&
      this.search_details.airlinepnr == "" &&
      this.search_details.order_id == "" &&
      this.search_details.Ticket_No == "" &&
      this.search_details.first_name == "" &&
      this.search_details.last_name == "" &&
      this.search_details.status == "E" &&
      this.search_details.emt == "" &&
      this.search_details.supplier_id == "" &&
      ((this.search_details.bookingdate_from == "" || this.search_details.bookingdate_from == null) ||
        (this.search_details.bookingdate_to == "" || this.search_details.bookingdate_to == null))
    ) {
      this.IsEmptyVal = false;
    } else {
      this.IsEmptyVal = true;
    }
    if (((this.search_details.bookingdate_from != "" && this.search_details.bookingdate_from != null) &&
      this.search_details.bookingdate_to == "" || this.search_details.bookingdate_to == null) || ((this.search_details.bookingdate_from == "" || this.search_details.bookingdate_from == null) &&
        this.search_details.bookingdate_to != "" && this.search_details.bookingdate_to != null)) {
      this.IsEmptyVal = false;
    }
  }

  jpNumberValidation() {
    this.disablebtn = false;
    var JPNo = this.search_details.jp_number;
    this.isJpNumber = this.commonService.validation('jpnumbervalidation', /^[A-Za-z0-9_]+$/, JPNo);
    this.IsErr = this.isJpNumber == true ? true : false;
  }

  pnrValidation() {
    this.disablebtn = false;

    var regex = /^[A-Za-z0-9_]+$/;
    this.search_details.airlinepnr = this.search_details.airlinepnr.toUpperCase();
    var JPNo = this.search_details.airlinepnr;

    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("pnrNO").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("pnrNO").style.color = "red";
      this.isPnr = true;
      this.IsErr = true;
    } else {
      document.getElementById("pnrNO").innerHTML = "";
      this.isPnr = false;
      this.IsErr = false;
    }
  }
  orderValidation() {
    this.disablebtn = false;
    var JPNo = this.search_details.order_id;
    this.isOrd = this.commonService.validation('orderValidation', /^[A-Za-z0-9_]+$/, JPNo);
    this.IsErr = this.isJpNumber == true ? true : false;
  }

  orderValidationOnBlur() {
    this.disablebtn = false;
    var JPNo = this.search_details.order_id;
    if (JPNo.length > 0) {
      if (JPNo.length < 14) {
        document.getElementById("orErr").innerHTML =
          "Please enter 18 digit Booking Reference No ";
        document.getElementById("orErr").style.color = "red";
        this.isOrd = true;
        this.IsErr = true;
      } else {
        document.getElementById("orErr").innerHTML = "";
        this.isOrd = false;
        this.IsErr = false;
      }
    }
  }
  EMTidValidation() {
    this.disablebtn = false;

    var regex = /^[A-Za-z0-9_]+$/;
    this.search_details.emt = this.search_details.emt.toUpperCase();
    var EmtId = this.search_details.emt;

    if (EmtId != "" && regex.test(EmtId) == false) {
      document.getElementById("EMT_id_err").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("EMT_id_err").style.color = "red";
      this.isEMT = true;
    } else {
      if (EmtId != "" && !EmtId.startsWith('EMT')) {
        document.getElementById("EMT_id_err").innerHTML = "Supplier ID start with EMT";
        document.getElementById("EMT_id_err").style.color = "red";
        this.isEMT = true;
        this.IsErr = true;
      } else {
        document.getElementById("EMT_id_err").innerHTML = "";
        this.isEMT = false;
        this.IsErr = false;
      }
    }

  }

  fnameValidation() {
    this.disablebtn = false;
    var regex = /^[A-Za-z]+$/;

    var JPNo = this.search_details.first_name;
    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("fnErr").innerHTML = "Only Alphabets allowed";
      document.getElementById("fnErr").style.color = "red";
      this.isFname = true;
      this.IsErr = true;
    } else {
      document.getElementById("fnErr").innerHTML = "";
      this.isFname = false;
      this.IsErr = false;
    }
  }
  lnameValidation() {
    this.disablebtn = false;
    var regex = /^[A-Za-z]+$/;

    var JPNo = this.search_details.last_name;

    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("lnErr").innerHTML = "Only Alphabets allowed";
      document.getElementById("lnErr").style.color = "red";
      this.isLname = true;
      this.IsErr = true;
    } else {
      document.getElementById("lnErr").innerHTML = "";
      this.isLname = false;
      this.IsErr = false;
    }
  }
  toggleDisable2() {
    this.journeydate = true;
    this.search_details.bookingdate_to = "";
  }
  incresedate() {
    var tomorrow = (document.getElementById("did") as HTMLInputElement).value;
    var tam = new Date(tomorrow);
    // console.log(tomorrow,"tomorrow");
    this.final = tam.setDate(tam.getDate());
    this.final = new Date(this.final);

    // alert(this.final);
    //alert(this.search_details.bookingdate_from);
  }
  reset3() {
    this.input3.value = "";

    this.search_details.bookingdate_from = "";
    this.tomorrow1 = "";
    this.isEmpty();
  }
  reset4() {
    this.input4.value = "";
    this.search_details.bookingdate_to = "";
    this.isEmpty();
  }
  checkStatus1() {
    //alert(this.search_details.bookingdate_from);
    // this.mydate = this.search_details.bookingdate_from;

    //    var endDate=startDate.setDate(startDate.getDate() + 1);

    // this.tomorrow = this.search_details.tripdate_from;
    //   // this.tomorrow = this.tomorrow.getDate() + 1;
    this.checkempty();
    this.showsingle1 = true;
    this.showMultiple1 = true;

    if (
      this.search_details.bookingdate_from != "" &&
      this.search_details.bookingdate_to != ""
    ) {
      this.downd = false;
      //  this.disablebtn = true;
      // this.checkempty();
    } else {
      this.downd = true;
    }
  }

  checkempty() {
    if (
      this.search_details.jp_number.length == 0 &&
      this.search_details.last_name.length == 0 &&
      this.search_details.first_name.length == 0 &&
      this.search_details.airlinepnr.length == 0 &&
      this.search_details.order_id.length == 0 &&
      this.search_details.emt.length == 0 &&
      this.search_details.supplier_id.length == 0 &&
      this.search_details.status == "E"
    ) {
      this.disablebtn = true;
    }

    if (
      (this.search_details.jp_number.length != 0 ||
        this.search_details.last_name.length != 0 ||
        this.search_details.first_name.length != 0 ||
        this.search_details.airlinepnr.length != 0 ||
        this.search_details.order_id.length != 0 ||
        this.search_details.emt.length == 0 ||
        this.search_details.supplier_id.length == 0 ||
        this.search_details.status != "E") &&
      (this.search_details.bookingdate_from != "" &&
        this.search_details.bookingdate_to != "")
    ) {
      this.disablebtn = false;
    }

    if (
      (this.search_details.jp_number.length != 0 ||
        this.search_details.last_name.length != 0 ||
        this.search_details.first_name.length != 0 ||
        this.search_details.airlinepnr.length != 0 ||
        this.search_details.order_id.length != 0 ||
        this.search_details.emt.length == 0 ||
        this.search_details.supplier_id.length == 0 ||
        this.search_details.status != "E") &&
      (this.search_details.bookingdate_from == "" &&
        this.search_details.bookingdate_to == "")
    ) {
      this.disablebtn = false;
    }

    if (
      this.search_details.bookingdate_from == "" &&
      this.search_details.bookingdate_to != ""
    ) {
      this.disablebtn = true;
    }

    if (
      this.search_details.bookingdate_from != "" &&
      this.search_details.bookingdate_to == ""
    ) {
      this.disablebtn = true;
    }
  }

  getFcrData(type) {
    this.noresult = "";
    this.loader = true;
    this.searchlist = false;
    this.cancelbtn = true;
    this.search_result_list = [];
    this.order_Id_list = [];
    this.search_detail_list = [];

    var Todate = this.search_details.bookingdate_to;
    if (Todate != "") {
      Todate.setDate(Todate.getDate());
    }
    this.search_details.bookingdate_from = this.datePipe.transform(
      this.search_details.bookingdate_from,
      "yyyy-MM-dd"
    );
    Todate = this.datePipe.transform(Todate, "yyyy-MM-dd");
    var boofrom = this.search_details.bookingdate_from;
    var bookto = Todate;
    if (this.search_details.order_id.startsWith("JPUB")) {
      var BOOKING_REF_NO = (this.search_details.order_id.toString().length > 12 ? this.search_details.order_id.slice(4, this.search_details.order_id.length) : this.search_details.order_id);
    } else {
      BOOKING_REF_NO = this.search_details.order_id;
    }

    var data = {
      jp_number: this.search_details.jp_number,
      order_id: BOOKING_REF_NO,
      first_name: this.search_details.first_name,
      last_name: this.search_details.last_name,
      airlinepnr: this.search_details.airlinepnr.toUpperCase(),
      booking_fromdate: boofrom,
      booking_todate: bookto,
      Ticket_No: this.search_details.Ticket_No,
      pagination: this.p,
      emtId: this.search_details.emt,
      type: type
    };
    // downloadFcrBooking
    if (type == 0) {
      this.vernostService.getFcrBooking(data).subscribe(response => {
        console.log("getFcrBookingResp>>>>", JSON.stringify(response));
        var Data = response;
        var count = Data[0].count;
        this.totalItems = count;
        this.search_result_list = Data[0].result;
        for (var i = 0; i < this.search_result_list.length; i++) {
          if (
            this.order_Id_list.indexOf(this.search_result_list[i].IM_BOOKING_ID) ==
            -1) {
            this.order_Id_list.push(this.search_result_list[i].IM_BOOKING_ID);
            this.search_detail_list.push(this.search_result_list[i]);
          }
        }

        if (
          this.search_detail_list.length == 0 ||
          this.search_detail_list == undefined ||
          this.search_detail_list == ""
        ) {
          // alert("here");git 
          this.noresult = "Result Not Found";
          this.loader = false;
          //document.getElementById("noresulrErr").innerHTML = "Result Not Found";
        } else {
          this.loader = false;
        }
      })
    } else {
      this.vernostService.downloadFcrBooking(data).subscribe(
        result => {
          // console.log("result",result.size);
          this.noresult = "";
          if (result.size != 0) {
            saveAs(result, "FC_Report_UBA_UBR.csv");
          } else {
            this.noresult = "Result Not Found";
          }
          this.loader = false;
        },
        err => { }
      );
    }

  }

  // DownloadData() {

  // }

  pageCount(count) {
    this.p = count;
    this.getFcrData(0);
    console.log("P:::", this.p);
  }


}
